import { render } from "./DetailAndCondition.vue?vue&type=template&id=49b8fb71&scoped=true"
import script from "./DetailAndCondition.vue?vue&type=script&lang=js"
export * from "./DetailAndCondition.vue?vue&type=script&lang=js"

import exportComponent from "F:\\work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b8fb71"]])

export default __exports__